module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customer settings":"Customer settings","language":"Language"},"de":{"customer settings":"Abmelden","language":"Sprache"}}')
  delete Component.options._Ctor
}
